export enum Roles {
    ADMIN = 1,
    REGION,
    PAIS,
    CLIENTE,
    USUARIO,
}

export enum Sistemas {
    EXCELBASE = 1,
}